export interface ITotalsBreakDown {
  totalToReconcile: number;
  totalCounted: number;
  depositsUnRedeemed: number;
  variance: number;
}